import { getListHashtagSearch } from 'clients/MarketingClient';
import { useAuth } from 'context/Auth';
import { useEffect, useState } from 'react';
import { TTL_CACHE_SERVER, WEB_HOST } from 'sysconfig';
import { CACHE_KEY, getWithExpiry, setWithExpiry } from 'utils/localStorageUtils';

export function useHashtagTopSearch({ ttl = TTL_CACHE_SERVER * 1000 } = {}) {
  const { user } = useAuth();
  const [hashtagTopSearch, setHashtagTopSearch] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const hashtags = await getHashtagTopSearches({ ttl, customerID: user?.customerID });
      setHashtagTopSearch(hashtags);
      setIsLoading(false);
    })();
  }, [user?.customerID]);

  return { hashtagTopSearch, isLoading };
}

async function getHashtagTopSearches({ ttl = TTL_CACHE_SERVER * 1000, customerID } = {}) {
  // Kèm customerID vì danh sách đã phụ thuộc khách; hai tài khoản dùng chung
  // trình duyệt không được thấy dữ liệu của nhau.
  const cacheKey = `${CACHE_KEY.HASHTAG_TOP_SEARCH}_${customerID || 'guest'}`;

  // Danh sách rỗng cũng là kết quả hợp lệ (khách không được xem hashtag nào),
  // getWithExpiry trả null khi thật sự chưa có cache.
  const cachedHashtags = getWithExpiry(cacheKey);
  if (cachedHashtags) {
    return cachedHashtags;
  }

  const res = await getListHashtagSearch({ isBasic: true });
  const hashtags =
    (res?.data || [])
      .filter((item) => {
        if (!item?.isActive) return false;

        const currentTime = new Date();
        const startDisplayTime = new Date(item.startDisplayTime);

        if (currentTime < startDisplayTime) return false;

        const endDisplayTime = new Date(item.endDisplayTime);
        if (currentTime > endDisplayTime) return false;

        return true;
      })
      .sort((hashtag1, hashtag2) => hashtag1?.ordinalNumber - hashtag2?.ordinalNumber)
      .map(({ code = '', hashtag = '', url = '', ...item }) => ({
        code,
        hashtag,
        url: url?.startsWith(WEB_HOST) ? url.replace(WEB_HOST, '') : url,
        ...item,
      })) || [];

  setWithExpiry(cacheKey, hashtags, { ttl });

  return hashtags;
}
